export const GET_USERS = "GET_USERS";

//================================  Add Job  ================================
export const GET_JOBTYPE = "GET_JOBTYPE";
export const GET_SUBTYPE = "GET_SUBTYPE";
export const GET_PREIOD = "GET_PREIOD";
export const ADD_JOB = "ADD_JOB";
export const GET_ASSET = "GET_ASSET";
//===========================================================================

//================================ Get All Job ==============================
export const GET_ALL_JOB = "GET_ALL_JOB";

//================================  Add Material  ================================
export const GET_MATERIAL = "GET_MATERIAL";
export const GET_SUPPLIER = "GET_SUPPLIER";
export const GET_UNIT = "GET_UNIT";
export const ADD_MATERIAL = "ADD_MATERIAL";

//================================================================================

//================================ Basic Data ====================================
export const GET_JOB_CATEGORY = "GET_JOB_CATEGORY";
export const GET_MA_SKILL = "GET_MA_SKILL";
export const ADD_MA_SKILL = "ADD_MA_SKILL";
export const GET_TEAM_GROUP = "GET_TEAM_GROUP";
export const CHECK_STATUS = "CHECK_STATUS";
export const POST_PERIOD = "POST_PERIOD";
export const GET_JOB_SUBTYPE = "GET_JOB_SUBTYPE";
export const UPDATE_JOBTYPE = "UPDATE_JOBTYPE";
export const ADD_JOBCATEGORY = "ADD_JOBCATEGORY";
export const GET_DIVISION = "GET_DIVISION";
export const UPDATE_DIVISION = "UPDATE_DIVISION";
export const GET_MA_LIST = "GET_MA_LIST";

export const DYNAMIC_SUBMIT = "DYNAMIC_SUBMIT";
export const GET_SUBMIT_DYNAMIC = "GET_SUBMIT_DYNAMIC";

export const ACTION_ADD = "ACTION_ADD";
export const SUBMIT_FORM = "SUBMIT_FORM";

export const OPERATION_STATE = "OPERATION_STATE";
